module.exports = __webpack_public_path__ + "img/44652a586d9fe515f7517695d4e6548f.png";